import PropTypes from 'prop-types';
const OrderStatusIcon = ({ height, width }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
            <mask id="mask0_2022_3140" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_2022_3140)">
                <path d="M5.61746 19C5.16547 19 4.78289 18.8367 4.46974 18.51C4.15658 18.1833 4 17.7843 4 17.3128V6.68723C4 6.21574 4.15658 5.81667 4.46974 5.49C4.78289 5.16333 5.16547 5 5.61746 5H19.3825C19.8345 5 20.2171 5.16333 20.5303 5.49C20.8434 5.81667 21 6.21574 21 6.68723V17.3128C21 17.7843 20.8434 18.1833 20.5303 18.51C20.2171 18.8367 19.8345 19 19.3825 19H5.61746ZM13.1711 17.6H15.7434V6.4H13.1711V17.6ZM9.25658 17.6H11.8289V6.4H9.25658V17.6ZM5.61746 17.6H7.91447V6.4H5.61746C5.53708 6.4 5.4711 6.42691 5.4195 6.48073C5.3679 6.53456 5.34211 6.60339 5.34211 6.68723V17.3128C5.34211 17.3966 5.3679 17.4654 5.4195 17.5193C5.4711 17.5731 5.53708 17.6 5.61746 17.6ZM17.0855 17.6H19.3825C19.4629 17.6 19.5289 17.5731 19.5805 17.5193C19.6321 17.4654 19.6579 17.3966 19.6579 17.3128V6.68723C19.6579 6.60339 19.6321 6.53456 19.5805 6.48073C19.5289 6.42691 19.4629 6.4 19.3825 6.4H17.0855V17.6Z" fill="var(--react-select-text)" />
            </g>
        </svg>
    )
};

OrderStatusIcon.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default OrderStatusIcon;